




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import ResetPasswordForm from '@/components/login/ResetPasswordForm.vue'
import RequestResetPasswordForm from '@/components/login/RequestResetPasswordForm.vue'

@Component({
  name: 'HomePage',
  components: {
    RequestResetPasswordForm,
    ResetPasswordForm
  }
})
export default class ResetPasswordPage extends Vue {
  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean
  displayedForm: string = 'request'

  @Prop({ default: '' })
  email!: string

  @Prop({ default: '' })
  token!: string

  created () {
    if (this.email && this.token) {
      this.displayedForm = 'reset'
    }
  }
}
